// extracted by mini-css-extract-plugin
export default {"navGroup":"theme_navGroup__RCrmh"};